import Debug from 'debug';

const LogLevel = {
  none: '-',
  all: '*',
  error: 'error',
  info: 'info',
  debug: 'debug',
  warning: 'warning',
};

class Log {
  constructor(workspace = '') {
    this.workspace = `${workspace}-`;
  }

  init = (level) => {
    let namespaces = Debug.disable();
    const newEnable = `${this.workspace}${level}`;
    if (namespaces) {
      namespaces = namespaces.split(',').filter((lev) => !lev.startsWith(this.workspace));
    }
    Debug.enable(namespaces ? `${namespaces},${newEnable}` : newEnable);
  };

  error = (...args) => {
    Debug(this.workspace + LogLevel.error)(...args);
  };

  info = (...args) => {
    Debug(this.workspace + LogLevel.info)(...args);
  };

  debug = (...args) => {
    Debug(this.workspace + LogLevel.debug)(...args);
  };

  warn = (...args) => {
    Debug(this.workspace + LogLevel.warning)(...args);
  };
}

Log.LogLevel = LogLevel;

export default Log;
